import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    height: '100%',
  },
}));

export default useStyles;
